export default "__VITE_ASSET__aF4zJ$VI__"